import { useMemo } from 'react';
import { useUpdateProjectMutation } from '../api';
/**
 * Hook to update a project.
 *
 * @returns a mutation function to update a project.
 */
export const useUpdateProject = () => {
    const [updateProject, { isLoading, isError, error }] = useUpdateProjectMutation();
    return useMemo(() => ({
        updateProject,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, updateProject]);
};
